.logo {
    width: 2rem;
}
.body {
    display: flex;
    height: calc(100vh - 3.7rem);
    & > nav {
        overflow-y: auto;
        min-width: fit-content;
    }
}
